import { render } from "./DiscussionQuestSearcher.vue?vue&type=template&id=71c34cce"
import script from "./DiscussionQuestSearcher.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./DiscussionQuestSearcher.vue?vue&type=script&charset=utf-8&lang=js"

import "./DiscussionQuestSearcher.vue?vue&type=style&index=0&id=71c34cce&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__